export const Instagram = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00016 1.26127C8.86907 1.26127 9.09039 1.26827 9.82869 1.30194C10.2726 1.30737 10.7123 1.38888 11.1286 1.54293C11.4306 1.65937 11.7048 1.83774 11.9336 2.06657C12.1624 2.29539 12.3408 2.5696 12.4572 2.87153C12.6113 3.28788 12.6928 3.72757 12.6982 4.17147C12.7316 4.90977 12.7389 5.13109 12.7389 7C12.7389 8.86891 12.7319 9.09023 12.6982 9.82853C12.6928 10.2724 12.6113 10.7121 12.4572 11.1285C12.3408 11.4304 12.1624 11.7046 11.9336 11.9334C11.7048 12.1623 11.4306 12.3406 11.1286 12.4571C10.7123 12.6111 10.2726 12.6926 9.82869 12.6981C9.09072 12.7314 8.8694 12.7387 7.00016 12.7387C5.13091 12.7387 4.90959 12.7317 4.17162 12.6981C3.72772 12.6926 3.28804 12.6111 2.87169 12.4571C2.56975 12.3406 2.29555 12.1623 2.06672 11.9334C1.8379 11.7046 1.65952 11.4304 1.54308 11.1285C1.38904 10.7121 1.30753 10.2724 1.30209 9.82853C1.26876 9.09023 1.26143 8.86891 1.26143 7C1.26143 5.13109 1.26843 4.90977 1.30209 4.17147C1.30753 3.72757 1.38904 3.28788 1.54308 2.87153C1.65952 2.5696 1.8379 2.29539 2.06672 2.06657C2.29555 1.83774 2.56975 1.65937 2.87169 1.54293C3.28804 1.38888 3.72772 1.30737 4.17162 1.30194C4.90992 1.26861 5.13124 1.26127 7.00016 1.26127ZM7.00016 0C5.10025 0 4.86092 0.0079996 4.11429 0.041998C3.53334 0.0535534 2.95855 0.163552 2.41437 0.367316C1.94756 0.543196 1.52475 0.818816 1.17543 1.17494C0.818983 1.52439 0.543127 1.94744 0.367138 2.41455C0.163374 2.95872 0.0533751 3.53351 0.0418197 4.11447C0.00848792 4.86044 0.000488281 5.09976 0.000488281 6.99967C0.000488281 8.89958 0.00848788 9.1389 0.0424863 9.88553C0.0540417 10.4665 0.164041 11.0413 0.367804 11.5854C0.543599 12.0525 0.819223 12.4755 1.17543 12.8251C1.52494 13.1813 1.94799 13.4569 2.41504 13.6327C2.95921 13.8364 3.534 13.9464 4.11496 13.958C4.86159 13.9913 5.09991 14 7.00082 14C8.90173 14 9.14005 13.992 9.88669 13.958C10.4676 13.9464 11.0424 13.8364 11.5866 13.6327C12.0514 13.4525 12.4736 13.1773 12.826 12.8247C13.1784 12.472 13.4533 12.0497 13.6332 11.5848C13.8369 11.0406 13.9469 10.4658 13.9585 9.88486C13.9918 9.1389 13.9998 8.89958 13.9998 6.99967C13.9998 5.09976 13.9918 4.86044 13.9578 4.1138C13.9463 3.53285 13.8363 2.95806 13.6325 2.41388C13.4567 1.94683 13.1811 1.52378 12.8249 1.17428C12.4754 0.818068 12.0523 0.542444 11.5853 0.366649C11.0411 0.162886 10.4663 0.0528868 9.88535 0.0413314C9.13939 0.00799964 8.90007 0 7.00016 0Z"
      fill="currentColor"
    />
    <path
      d="M7.00172 3.40674C6.2908 3.40674 5.59584 3.61755 5.00473 4.01252C4.41362 4.40749 3.9529 4.96887 3.68084 5.62568C3.40878 6.28249 3.3376 7.00522 3.4763 7.70249C3.61499 8.39975 3.95733 9.04023 4.46003 9.54293C4.96273 10.0456 5.60321 10.388 6.30047 10.5267C6.99774 10.6654 7.72047 10.5942 8.37728 10.3221C9.03409 10.0501 9.59547 9.58934 9.99044 8.99823C10.3854 8.40712 10.5962 7.71216 10.5962 7.00123C10.5962 6.04791 10.2175 5.13364 9.54342 4.45954C8.86932 3.78544 7.95504 3.40674 7.00172 3.40674ZM7.00172 9.33446C6.54026 9.33446 6.08915 9.19762 5.70546 8.94124C5.32176 8.68486 5.0227 8.32046 4.84611 7.89412C4.66951 7.46778 4.62331 6.99865 4.71333 6.54604C4.80336 6.09344 5.02558 5.6777 5.35189 5.3514C5.67819 5.02509 6.09393 4.80287 6.54654 4.71284C6.99914 4.62282 7.46827 4.66902 7.89461 4.84562C8.32095 5.02221 8.68535 5.32127 8.94173 5.70497C9.19811 6.08866 9.33495 6.53977 9.33495 7.00123C9.33495 7.62004 9.08913 8.21351 8.65156 8.65107C8.214 9.08864 7.62053 9.33446 7.00172 9.33446Z"
      fill="currentColor"
    />
    <path
      d="M10.7374 4.10326C11.2013 4.10326 11.5774 3.7272 11.5774 3.2633C11.5774 2.7994 11.2013 2.42334 10.7374 2.42334C10.2735 2.42334 9.89746 2.7994 9.89746 3.2633C9.89746 3.7272 10.2735 4.10326 10.7374 4.10326Z"
      fill="currentColor"
    />
  </svg>
);

export const Facebook = () => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.70775 13.0875V7.53396H0.838867V5.36963H2.70775V3.7735C2.70775 1.92121 3.83907 0.912598 5.49144 0.912598C6.28295 0.912598 6.96321 0.971527 7.16145 0.997866V2.93362L6.01544 2.93414C5.11679 2.93414 4.94278 3.36117 4.94278 3.9878V5.36963H7.08599L6.80693 7.53396H4.94278V13.0875H2.70775Z"
      fill="currentColor"
    />
  </svg>
);

export const Twitter = () => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.585 1.91193C13.0912 2.13143 12.5699 2.26862 12.0211 2.35093C12.5699 2.02168 13.0089 1.50037 13.2009 0.869309C12.6796 1.17112 12.1034 1.39062 11.4724 1.52781C10.9785 1.0065 10.2651 0.677246 9.49685 0.677246C8.01523 0.677246 6.80798 1.8845 6.80798 3.36612C6.80798 3.58562 6.83541 3.77768 6.89029 3.96975C4.66785 3.86 2.66491 2.78993 1.32048 1.14368C1.10098 1.55525 0.963789 1.99425 0.963789 2.48812C0.963789 3.421 1.43023 4.24412 2.17104 4.738C1.73204 4.71056 1.32048 4.60081 0.936352 4.40875V4.43618C0.936352 5.75318 1.86923 6.85068 3.10391 7.09762C2.88441 7.1525 2.63748 7.17993 2.39054 7.17993C2.22591 7.17993 2.03385 7.1525 1.86923 7.12506C2.22591 8.19512 3.21366 8.99081 4.39348 8.99081C3.4606 9.70418 2.30823 10.1432 1.0461 10.1432C0.826602 10.1432 0.607102 10.1432 0.415039 10.1157C1.62229 10.884 3.0216 11.323 4.5581 11.323C9.52429 11.323 12.2406 7.20737 12.2406 3.6405C12.2406 3.53075 12.2406 3.39356 12.2406 3.28381C12.7619 2.92712 13.2284 2.46068 13.585 1.91193Z"
      fill="currentColor"
    />
  </svg>
);

export const Whatsapp = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.60016 13.7335C5.60016 14.3335 6.80016 14.6668 8.00016 14.6668C11.6668 14.6668 14.6668 11.6668 14.6668 8.00016C14.6668 4.3335 11.6668 1.3335 8.00016 1.3335C4.3335 1.3335 1.3335 4.3335 1.3335 8.00016C1.3335 9.20016 1.66683 10.3335 2.20016 11.3335L1.77394 12.9728C1.57922 13.7218 2.27242 14.3986 3.01648 14.186L4.60016 13.7335Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 9.899C11 10.007 10.976 10.118 10.9249 10.226C10.8738 10.334 10.8077 10.436 10.7206 10.532C10.5734 10.694 10.4111 10.811 10.2278 10.886C10.0476 10.961 9.85228 11 9.64196 11C9.3355 11 9.00801 10.928 8.66249 10.781C8.31698 10.634 7.97146 10.436 7.62894 10.187C7.28343 9.935 6.95593 9.656 6.64347 9.347C6.334 9.035 6.05458 8.708 5.80521 8.366C5.55884 8.024 5.36054 7.682 5.21632 7.343C5.07211 7.001 5 6.674 5 6.362C5 6.158 5.03605 5.963 5.10816 5.783C5.18027 5.6 5.29444 5.432 5.45368 5.282C5.64597 5.093 5.85628 5 6.07862 5C6.16274 5 6.24687 5.018 6.32198 5.054C6.4001 5.09 6.4692 5.144 6.52329 5.222L7.22033 6.203C7.27441 6.278 7.31347 6.347 7.34051 6.413C7.36755 6.476 7.38257 6.539 7.38257 6.596C7.38257 6.668 7.36154 6.74 7.31948 6.809C7.28042 6.878 7.22334 6.95 7.15123 7.022L6.92288 7.259C6.88983 7.292 6.87481 7.331 6.87481 7.379C6.87481 7.403 6.87782 7.424 6.88383 7.448C6.89284 7.472 6.90185 7.49 6.90786 7.508C6.96194 7.607 7.05508 7.736 7.18728 7.892C7.32248 8.048 7.4667 8.207 7.62293 8.366C7.78518 8.525 7.94141 8.672 8.10065 8.807C8.25689 8.939 8.38608 9.029 8.48823 9.083C8.50325 9.089 8.52128 9.098 8.54231 9.107C8.56635 9.116 8.59039 9.119 8.61743 9.119C8.6685 9.119 8.70756 9.101 8.74061 9.068L8.96895 8.843C9.04407 8.768 9.11617 8.711 9.18528 8.675C9.25438 8.633 9.32349 8.612 9.3986 8.612C9.45568 8.612 9.51577 8.624 9.58187 8.651C9.64797 8.678 9.71708 8.717 9.79219 8.768L10.7867 9.473C10.8648 9.527 10.9189 9.59 10.9519 9.665C10.982 9.74 11 9.815 11 9.899Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

export const LinkedIn = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9H2V21H6V9Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 8C17.5913 8 19.1174 8.63214 20.2426 9.75736C21.3679 10.8826 22 12.4087 22 14V21H18V14C18 13.4696 17.7893 12.9609 17.4142 12.5858C17.0391 12.2107 16.5304 12 16 12C15.4696 12 14.9609 12.2107 14.5858 12.5858C14.2107 12.9609 14 13.4696 14 14V21H10V14C10 12.4087 10.6321 10.8826 11.7574 9.75736C12.8826 8.63214 14.4087 8 16 8V8Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
